import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FeatureConfigService } from './feature-config.service';
import { FeatureConfigResponseDTO } from '@libs/api';
import { isCrossChannelDashboards } from '@portal/app/shared/constants/constants';

@Injectable({ providedIn: 'root' })
export class FiscalCalendarStateService {
  private readonly featureConfigService = inject(FeatureConfigService);
  private isCustomCalendar = false;
  readonly ready$ = new BehaviorSubject<boolean>(false);

  isFeatureEnabled(): boolean {
    return this.featureConfigService.isFeatureEnabled(
      FeatureConfigResponseDTO.FeatureNameEnum.FiscalCalendar
    );
  }

  onFiscalCalendarQuerySuccess(isCustomCalendar: boolean): void {
    this.isCustomCalendar = isCustomCalendar;
    if (!this.ready$.value) {
      this.ready$.next(true);
    }
  }

  getIsFiscalCalendarEnabled(dashboardLiteralId: string): boolean | undefined {
    return isCrossChannelDashboards(dashboardLiteralId)
      ? this.isFeatureEnabled() && this.isCustomCalendar
      : undefined;
  }
}
